export const API_BASE_URL = process.env.REACT_APP_RAYCHAT_BASE_API_PORT
  ? process.env.REACT_APP_RAYCHAT_BASE_API_URL +
    ':' +
    process.env.REACT_APP_RAYCHAT_BASE_API_PORT
  : process.env.REACT_APP_RAYCHAT_BASE_API_URL;
export const RAYCHAT_APP_URL = process.env.REACT_APP_RAYCHAT_APP_URL;
export const RAYCHAT_APP_V2_URL = process.env.REACT_APP_RAYCHAT_APP_V2_URL;
export const RAYCHAT_IMAGES_URL = process.env.REACT_APP_RAYCHAT_IMAGES_URL;
export const API_URL = process.env.REACT_APP_RAYCHAT_API_URL;
export const RAYCHAT_WEBSITE_URL = process.env.REACT_APP_RAYCHAT_WEBSITE_URL;
export const WHATSAPP_CONNECT_URL = process.env.REACT_APP_CONNECT_WHATSAPP_URL;
export const SOCKET_CONNECT_URL = process.env.REACT_APP_CONNECT_SOCKET_URL;
export const RAYCHAT_HELP_URL = process.env.REACT_APP_RAYCHAT_HELP_URL;
export const RAYCHAT_INSTALL_PLUGIN_URL =
  process.env.REACT_APP_RAYCHAT_INSTALL_PLUGIN_URL;
export const DEPARTMENTS_API_URL = process.env.REACT_APP_DEPARTMENTS_API_URL;
export const RAYCHAT_GATEWAY_API_URL = process.env.REACT_APP_GATEWAY_API_URL;
export const RAYCHAT_FAQ_API_URL = process.env.REACT_APP_FAQ_API_URL;
export const RAYCHAT_UPLOAD_FILE_URL =
  process.env.REACT_APP_RAYCHAT_UPLOAD_FILE_URL;
export const RAYCHAT_NEW_DEFAULT_LOGOS =
  process.env.REACT_APP_NEW_DEFAULT_LOGOS;
export const RAYCHAT_AFFILIATE_URL = process.env.REACT_APP_AFFILIATE_URL;
export const RAYCHAT_AFFILIATE_API_URL =
  process.env.REACT_APP_AFFILIATE_API_URL;
export const RAYCHAT_AFFILIATE_PUT_API_URL =
  process.env.REACT_APP_AFFILIATE_PUT_API_URL;

// for widget installations code
export const RAYCHAT_WIDGET_INSTALL_URL =
  process.env.REACT_APP_WIDGET_INSTALLATION_URL;

// for widget that is installed on dashboard
export const RAYCHAT_WIDGET_INSTALLED_ON_DASHBOARD_URL =
  process.env.REACT_APP_WIDGET_SRC_URL;

export const RAYCHAT_WIDGET_LINK_URL = process.env.REACT_APP_WIDGET_LINK_URL;
export const RAYCHAT_WIDGET_TOKEN = process.env.REACT_APP_WIDGET_TOKEN;

export const REACT_APP_APPS_LIST_LINK = process.env.REACT_APP_APPS_LIST_LINK;

export const DEFAULT_AVATAR_IMAGE_URL = `${RAYCHAT_IMAGES_URL}/images/avatar-agent-default.svg`;

export const REACT_APP_HELP_CENTER = process.env.REACT_APP_HELP_CENTER_URL;

export const POPUP_NAMES = {
  NEW_FEATURES: 'RAYCHAT_DASHBOARD_NEW_FEATURES',
};
